export default "__VITE_PUBLIC_ASSET__ab7cd0c0__"